import type { NextFn } from 'types/adapters'

interface PreviousActionMeta {
  previousAction?: {
    payload?: unknown
  }
}

interface PreviousAction {
  meta?: PreviousActionMeta
  previousPayload?: unknown
  [key: string]: unknown
}

export default () => (next: NextFn<PreviousAction>) => (action: PreviousAction) => {
  action.previousPayload = action.meta?.previousAction?.payload
  return next(action)
}
